import { MARKET_CONSTS } from "../constants";

export const initialState = {
    marketsList: [],
    marketById: null
};

export default (state = initialState, action) => {
    switch ( action.type ) {
        case MARKET_CONSTS.GET_MARKETS:
            return {
                ...state,
                marketsList: action.payload || [],
            };
        case MARKET_CONSTS.CREATE_MARKET:
            return {
                ...state,
                marketsList: [action.payload].concat(state.marketsList)
            };
        case MARKET_CONSTS.GET_MARKET_BY_ID:
            return {
                ...state,
                marketById: action.payload
            };
        case MARKET_CONSTS.UPDATE_MARKET_BY_ID:
            return {
                ...state,
                marketsList: state.marketsList.map(item => item.id === action.payload?.id ? action.payload : item)
            };
        case MARKET_CONSTS.DELETE_MARKET_BY_ID:
            return {
                ...state,
                marketsList: state.marketsList.filter(item => item.id !== action.payload)
            };
        case MARKET_CONSTS.CLEAR_MARKET_DATA:
            return {
                ...state,
                marketById: null
            };
        default:
            return state;
    }
}
